<div class="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1 h-100">
  <!-- Start User chat -->
  <div class="user-chat w-100 overflow-hidden">
    <div class="chat-content d-lg-flex">
      <div class="w-100 overflow-hidden position-relative">
        <div class="position-relative">
          <div class="p-3 user-chat-topbar">
            <div class="row align-items-center">
              <div class="col-sm-4 col-8">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 d-block d-lg-none me-3">
                    <a href="javascript: void(0);" class="user-chat-remove fs-18 p-1"><i
                        class="ri-arrow-left-s-line align-bottom"></i></a>
                  </div>
                  <div class="flex-grow-1">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 chat-user-img user-own-img align-self-center me-3 ms-0"
                        [class.away]="isStatus == 'away'" [class.online]="isStatus == 'online'">
                        <img src="{{isProfile}}" class="rounded-circle avatar-xs" alt="">
                        <span class="user-status"></span>
                      </div>
                      <div class="flex-grow-1">
                        <h5 class="text-nowrap mb-0 fs-16">
                          <a class="text-reset username">{{username}}</a>
                        </h5>
                        <p class="text-truncate text-muted fs-14 mb-0 userStatus"><small>
                            {{ isStatus | titlecase }}</small></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>




        <div class="position-relative" id="users-chat">
          <ngx-simplebar class="chat-conversation p-3 p-lg-4" #scrollRef>
            <!-- summary -->
            <div class="custom-accordion">
              @if (!isLoading && chatMessages) {
              <div ngbAccordion (click)="$event.stopPropagation()" class="accordion-flush" #acc="ngbAccordion"
                activeIds="static-1" [closeOthers]="false">
                <!-- First Transaction Summary -->
                <div ngbAccordionItem id="static-1" class="accordion-item">
                  <h2 ngbAccordionHeader class="accordion-header">
                    <button ngbAccordionButton class="accordion-button">
                      <span class="fw-bold">Transaction Summary</span>
                    </button>
                  </h2>
                  <div ngbAccordionCollapse class="accordion-collapse">
                    <div ngbAccordionBody class="accordion-body">
                      <div>
                        <p>All your transactions took place on February 23, 2024:</p>
                        <ul>
                          <li><span class="fw-bold me-2">Total transactions:</span> <span class="text-muted">4</span>
                          </li>
                          <li><span class="fw-bold me-2">Bank:</span> <span class="text-muted">Lean
                              Model Bank</span></li>
                          <li><span class="fw-bold me-2">Inflow transactions:</span> <span class="text-muted">2</span>
                          </li>
                          <li><span class="fw-bold me-2">Total inflow:</span> <span class="text-muted">31,161.77</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Second Summary: Spending Behavior -->
                <div ngbAccordionItem id="static-2" class="accordion-item">
                  <h2 ngbAccordionHeader class="accordion-header">
                    <button ngbAccordionButton class="accordion-button">
                      <span class="fw-bold">Spending Behavior Analysis</span>
                    </button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <div>
                        <p>Your spending behavior over the last month:</p>
                        <ul>
                          <li><span class="fw-bold me-2">Total spent:</span> <span class="text-muted">1,250.00</span>
                          </li>
                          <li><span class="fw-bold me-2">Highest spending category:</span>
                            <span class="text-muted">Dining</span>
                          </li>
                          <li><span class="fw-bold me-2">Most frequent vendor:</span>
                            <span class="text-muted">Local Cafe</span>
                          </li>
                          <li><span class="fw-bold me-2">Savings potential:</span> <span
                              class="text-muted">200.00</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Third Summary: Financial Health Overview -->
                <div ngbAccordionItem id="static-3" class="accordion-item">
                  <h2 ngbAccordionHeader class="accordion-header">
                    <button ngbAccordionButton class="accordion-button">
                      <span class="fw-bold">Financial Health Overview</span>
                    </button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <div>
                        <p>Your financial health as of April 1, 2024, is as follows:</p>
                        <ul>
                          <li><span class="fw-bold me-2">Current savings:</span> <span
                              class="text-muted">5,000.00</span></li>
                          <li><span class="fw-bold me-2">Debt level:</span> <span class="text-muted">2,500.00</span>
                          </li>
                          <li><span class="fw-bold me-2">Credit score:</span> <span class="text-muted">720</span></li>
                          <li><span class="fw-bold me-2">Investment growth:</span> <span class="text-muted">15%</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>

            <!-- Predefined Prompts Section -->
            @if (!isLoading && chatMessages) {
            <div class="d-flex justify-content-center align-items-center prompt">
              <div class="p-3 mx-2">
                <div class="d-flex flex-row flex-wrap flex-grow-1 justify-content-center gap-3 p-3 button-group">
                  <button class="btn btn-outline-primary btn-lg d-flex align-items-center gap-2"
                    (click)="setPredefinedPrompt('Number of transactions')">
                    <i class="ri-file-list-line"></i>
                    Number of Transactions
                  </button>
                  <button class="btn btn-outline-primary btn-lg d-flex align-items-center gap-2"
                    (click)="setPredefinedPrompt('Find patterns in transaction data')">
                    <i class="ri-line-chart-line"></i>
                    Find Patterns in Transaction Data
                  </button>
                  <button class="btn btn-outline-primary btn-lg d-flex align-items-center gap-2"
                    (click)="setPredefinedPrompt('Account Management')">
                    <i class="ri-bank-line"></i>
                    Account Management
                  </button>
                  <button class="btn btn-outline-primary btn-lg d-flex align-items-center gap-2"
                    (click)="setPredefinedPrompt('Analyze transaction history')">
                    <i class="ri-bar-chart-line"></i>
                    Analyze Transaction History
                  </button>
                </div>
              </div>
            </div>
            }



            <!-- start loader -->
            @if (isLoading) {
            <div class="inner-loader">
              <i class="las la-sync rotate-img fs-24"></i>
            </div>
            }
            @if (!isLoading && chatMessages) {
            <ul class="list-unstyled chat-conversation-list" id="users-conversation">
              @for (data of chatMessages.messages; track $index; let index = $index) {
              <li class="chat-list left" [class.right]="(index % 2) == 1">
                <div class="conversation-list">
                  @if (data.profile) {
                  <div class="chat-avatar">
                    <img src="{{data.profile}}" alt="">
                  </div>
                  }
                  <div class="user-chat-content">
                    <div class="ctext-wrap">
                      <div class="ctext-wrap-content">
                        <p class="mb-0 ctext-content">{{data.content}}</p>
                      </div>
                    </div>
                    <div class="conversation-name">
                      <small class="text-muted time">{{data.time}}</small>
                    </div>
                  </div>
                </div>
              </li>
              }
            </ul>
            }
          </ngx-simplebar>
        </div>

        @if (!isLoading && chatMessages) {
        <div class="chat-input-section p-3 p-lg-4">
          <form (ngSubmit)="messageSave()" [formGroup]="chatForm" id="chatinput-form" enctype="multipart/form-data">
            <div class="row g-0 align-items-center">
              <div class="col">
                @if (submitted && form['message'].errors) {
                <div class="chat-input-feedback">
                  @if (form['message'].errors['required']) {
                  <span>Please Enter a Message</span>
                  }
                </div>
                }
                <input type="text" class="form-control chat-input bg-light border-light" id="chat-input"
                  placeholder="Type your message..." autocomplete="off" formControlName="message"
                  [class.is-invalid]="submitted && form['message'].errors">
              </div>
              <div class="col-auto">
                <div class="chat-input-links ms-2">
                  <div class="links-list-item">
                    <button type="submit" class="btn btn-primary chat-send waves-effect waves-light shadow"
                      [disabled]="submitted && chatForm.valid ">
                      @if (!(submitted && chatForm.valid)) {
                      <i class="ri-send-plane-2-fill align-bottom"></i>
                      }
                      @if (submitted && chatForm.valid) {
                      <i class="mdi mdi-loading mdi-spin fs-13 align-middle">
                      </i>
                      }
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        }
      </div>
    </div>
  </div>
</div>


<!-- <div class="inner-loader" *ngIf="isLoading">
<i class="las la-sync rotate-img fs-24"></i>
</div> -->

<!-- <div class="inner-overlay" *ngIf="!isLoading && !chatMessages">
<button class="btn btn-primary" (click)="startConversion()">
  Start Conversation
</button>
</div> -->